import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { authRoles } from "../../../auth/authRoles";

const DtJudgementTable = Loadable(lazy(() => import("../caseLaw/App")));
const StatutesTable = Loadable(lazy(() => import("../statutes/App")));
const ActsTable = Loadable(lazy(() => import("../acts/App")));
const RulesTable = Loadable(lazy(() => import("../rules/App")));
const ReckonerTable = Loadable(lazy(() => import("../reckoner/App")));
const DtaaTable = Loadable(lazy(() => import("../dtaa/App")));
const FinanceActTable = Loadable(lazy(() => import("../financeAct/App")));
const DtcTable = Loadable(lazy(() => import("../dtc/App")));
const QueryTable = Loadable(lazy(() => import("../query/App")));
// const KnowledgeTable = Loadable(lazy(() => import("../knowledge/App")));
const ArticleTable = Loadable(lazy(() => import("../article/App")));
const FAQTable = Loadable(lazy(() => import("../faq/App")));
const NoticeTable = Loadable(lazy(() => import("../notice/App")));

const directTaxRoutes = [
  { path: "/dt/judgements", element: <DtJudgementTable />, auth: authRoles.guest},
  { path: "/dt/judgements/:id/*", element: <DtJudgementTable />, auth: authRoles.guest },
  { path: "/dt/statutes", element: <StatutesTable />, auth: authRoles.guest},
  { path: "/dt/statutes/:id/*", element: <StatutesTable />, auth: authRoles.guest },
  { path: "/dt/acts", element: <ActsTable />, auth: authRoles.guest},
  { path: "/dt/acts/:id/*", element: <ActsTable />, auth: authRoles.guest },
  { path: "/dt/rules", element: <RulesTable />, auth: authRoles.guest},
  { path: "/dt/rules/:id/*", element: <RulesTable />, auth: authRoles.guest },
  { path: "/dt/reckoner", element: <ReckonerTable />, auth: authRoles.guest},
  { path: "/dt/reckoner/:id/*", element: <ReckonerTable />, auth: authRoles.guest },
  { path: "/dt/dtaa", element: <DtaaTable />, auth: authRoles.guest},
  { path: "/dt/dtaa/:id/*", element: <DtaaTable />, auth: authRoles.guest },
  { path: "/dt/finance-acts", element: <FinanceActTable />, auth: authRoles.guest},
  { path: "/dt/finance-acts/:id/*", element: <FinanceActTable />, auth: authRoles.guest },
  { path: "/dt/dtc", element: <DtcTable />, auth: authRoles.guest},
  { path: "/dt/dtc/:id/*", element: <DtcTable />, auth: authRoles.guest },
  { path: "/dt/query", element: <QueryTable />, auth: authRoles.guest},
  { path: "/dt/query/:id/*", element: <QueryTable />, auth: authRoles.guest },
  // { path: "/dt/knowledge", element: <KnowledgeTable />, auth: authRoles.guest},
  // { path: "/dt/knowledge/:id/*", element: <KnowledgeTable />, auth: authRoles.guest },
  { path: "/dt/article", element: <ArticleTable />, auth: authRoles.guest},
  { path: "/dt/article/:id/*", element: <ArticleTable />, auth: authRoles.guest },
  { path: "/dt/faq", element: <FAQTable />, auth: authRoles.guest},
  { path: "/dt/faq/:id/*", element: <FAQTable />, auth: authRoles.guest },
  { path: "/dt/notice", element: <NoticeTable />, auth: authRoles.guest},
  { path: "/dt/notice/:id/*", element: <NoticeTable />, auth: authRoles.guest },
];

export default directTaxRoutes;
